import { FC, useState, useEffect } from 'react';
import { Box, TextField, Typography, Button, Autocomplete, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IHsCodeItem } from 'redux/reducers/hscodes/types';
import { ManualFieldProps } from './types';

export const ManualField: FC<ManualFieldProps> = ({
	label,
	manualInputValue,
	manualHsCodeOptions,
	manualHsCodeLoading,
	hsCodeStack,
	finalHsCode,
	currentPath,
	currentSelection,
	canGoBack,
	isComplete,
	onManualInputChange,
	onManualValueChange,
	onGoBack,
	onReset,
	onFocus,
	onChange,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	// Автоматически показываем список после загрузки новых опций
	useEffect(() => {
		if (manualHsCodeOptions.length > 0 && !isComplete && !manualHsCodeLoading) {
			setIsOpen(true);
		}
	}, [manualHsCodeOptions, isComplete, manualHsCodeLoading]);

	return (
		<Box>
			<Autocomplete<IHsCodeItem>
				size="small"
				options={manualHsCodeOptions}
				loading={manualHsCodeLoading}
				value={manualInputValue ? currentSelection : null}
				inputValue={manualInputValue}
				onInputChange={(event, newInputValue) => {
					onManualInputChange(newInputValue);
				}}
				onChange={(event, newValue) => {
					if (newValue === null) {
						onManualInputChange('');
						onManualValueChange(null);
						onReset();
					} else {
						onManualValueChange(newValue);
					}
				}}
				onFocus={() => {
					onFocus();
					if (manualHsCodeOptions.length > 0 && !isComplete) {
						setIsOpen(true);
					}
				}}
				onBlur={() => setIsOpen(false)}
				getOptionLabel={(option) => `${option.code} - ${option.description}`}
				renderOption={(props, option) => (
					<Box component="li" {...props}>
						<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
							{option.code}
						</Typography>
						<Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
							{option.description}
						</Typography>
					</Box>
				)}
				renderInput={(params) => (
					<TextField
						{...params}
						label={`${label} (Manual selection)`}
						placeholder="Click to start selection..."
						variant="outlined"
						helperText={
							isComplete
								? '✓ Final HS Code selected'
								: currentSelection
									? 'Select next level or click to continue'
									: 'Click to start hierarchical selection'
						}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{canGoBack && (
										<IconButton
											size="small"
											onClick={onGoBack}
											disabled={manualHsCodeLoading}
											sx={{
												mr: 1,
												opacity: 0,
												'.MuiAutocomplete-root:hover &, .MuiAutocomplete-root:focus-within &': {
													opacity: 1,
												},
											}}
										>
											<ArrowBackIcon fontSize="small" />
										</IconButton>
									)}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
				noOptionsText="No options available"
				loadingText="Loading..."
				open={isOpen && manualHsCodeOptions.length > 0 && !isComplete}
				freeSolo={false}
				disableClearable={false}
				blurOnSelect
			/>

			{/* Отладочная информация */}
			{/* <Box sx={{ mt: 1, p: 1, bgcolor: 'grey.100', borderRadius: 1 }}>
				<Typography variant="caption" component="div">
					Debug info:
				</Typography>
				<Typography variant="caption" component="div">
					Options length: {manualHsCodeOptions.length}
				</Typography>
				<Typography variant="caption" component="div">
					Loading: {manualHsCodeLoading ? 'true' : 'false'}
				</Typography>
				<Typography variant="caption" component="div">
					Is complete: {isComplete ? 'true' : 'false'}
				</Typography>
				<Typography variant="caption" component="div">
					Current selection:{' '}
					{currentSelection ? `${currentSelection.code} - ${currentSelection.description}` : 'none'}
				</Typography>
				<Typography variant="caption" component="div">
					Current list:{' '}
					<ul>
						{manualHsCodeOptions.map((item) => (
							<li key={item.code}>{`${item.code} - ${item.description}`}</li>
						))}
					</ul>
				</Typography>
			</Box> */}

			{/* {isComplete && finalHsCode && (
				<Box sx={{ p: 2, bgcolor: 'success.light', borderRadius: 1, mt: 2 }}>
					<Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'success.dark' }}>
						✓ Final HS Code: {finalHsCode.code}
					</Typography>
					<Typography variant="body2" sx={{ color: 'success.dark' }}>
						{finalHsCode.description}
					</Typography>
				</Box>
			)} */}
		</Box>
	);
};
